import React, { Component, PropTypes } from 'react';
import { Units, Colors, hexToRgba } from 'Css';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Loader from 'components/Material/Loader';
import CardList from 'components/CardList';
import { TextField } from 'material-ui';

const css = oxygenCss({
  root: {
    margin: Units.base,
    borderRadius: 2,
    backgroundColor: Colors.theme.Light.card,
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)'
  },
  title: {
    padding: Units.base / 2,
    borderStyle: 'none none solid none',
    borderColor: '#DDD',
    borderWidth: 1
  },
  list: {
    height: 400,
    overflow: 'auto',
    '&mini': {
      height: 120
    }
  },
  bottomBar: {
    backgroundColor: Colors.material.grey[500].hex,
    color: Colors.material.grey[500].text.default,
    padding: Units.base,
    fontSize: 12,
    lineHeight: '20px'
  },
  listItem: {
    fontSize: 16,
    lineHeight: '24px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: Units.base,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: `${hexToRgba(
        Colors.material.coursio[500].hex,
        25
      )} !important`
    },
    '&selected': {
      backgroundColor: `${hexToRgba(Colors.material.coursio[300].hex, 40)}`,
      color: Colors.material.coursio[300].text.default
    }
  }
});

class FilterList extends Component {
  static propTypes = {
    title: PropTypes.string,
    filter: PropTypes.string,
    list: PropTypes.array,
    onFilterChange: PropTypes.func,
    onChange: PropTypes.func,
    loading: PropTypes.bool,
    mini: PropTypes.bool,
    selected: PropTypes.object
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  _handleFilterChange = event => {
    const { value: filter } = event.target;
    const { onFilterChange } = this.props;
    onFilterChange && onFilterChange(filter);
  };

  _handleTouchTap = item => {
    const { onChange, selected } = this.props;
    onChange &&
      onChange({
        ...selected,
        [item.id]: !selected[item.id]
      });
  };

  render() {
    const { title, list, selected, loading, filter, mini } = this.props;

    const { getIntlMessage } = this.context;

    return (
      <CardList
        mini={mini}
        constrained
        header={
          <TextField
            fullWidth
            hintText={title}
            onChange={this._handleFilterChange}
            value={filter}
          />
        }
        footer={
          <FormattedMessage
            message={getIntlMessage('selectedCount')}
            num={Object.keys(selected).length}
          />
        }
      >
        {loading && <Loader />}
        {!loading &&
          list.map(item => {
            const { id } = item;
            if (id) {
              return (
                <div
                  key={id}
                  onTouchTap={this._handleTouchTap.bind(this, item)}
                  className={classNames(
                    css.listItem,
                    selected[id] && css.selected
                  )}
                >
                  {item.name}
                </div>
              );
            }
          })}
      </CardList>
    );
  }
}

export default FilterList;



// WEBPACK FOOTER //
// ./src/js/components/Tasks/FilterList.js